"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoQuoteRequestReceived = void 0;
const typebox_1 = require("@sinclair/typebox");
// d-ea2788957c5143d0928c95b03d003299
exports.RoQuoteRequestReceived = typebox_1.Type.Object({
    /**
     * as an empty string or in yyyy-mm-dd format
     */
    last_order_date: typebox_1.Type.String(),
    first_name: typebox_1.Type.String(),
    dumpster_size: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
});
//# sourceMappingURL=ro-quote-request-received.js.map